document.addEventListener("DOMContentLoaded", function () {
  const ANIMATION_DELAY = 200;

  // --- Centralised environment detection -----------------------------------
  const mqHover = window.matchMedia("(hover: hover) and (pointer: fine)");
  const mqWidth = window.matchMedia("(min-width: 768px)");

  function computeHoverMode() {
    return mqHover.matches && mqWidth.matches;
  }
  function isSmallLayout() {
    return !mqWidth.matches;
  } // <768px

  let hoverMode = computeHoverMode();
  let smallLayout = isSmallLayout();
  // -------------------------------------------------------------------------

  const megaMenuWrapper = document.querySelector(".mega-menu-wrapper");
  const menuItemsWithMegaMenu = Array.from(
    document.querySelectorAll(".main-nav__item--has-mega-menu")
  );
  const allMenuItems = Array.from(document.querySelectorAll(".main-nav__item"));
  const sectionHeader = document.querySelector(".section-header");

  const itemToMenu = new Map();

  const menusByKey = new Map(
    Array.from(document.querySelectorAll(".mega-menu[data-menu-item]")).map(
      (el) => [(el.dataset.menuItem || "").trim().toLowerCase(), el]
    )
  );

  menuItemsWithMegaMenu.forEach((item) => {
    const key = (item.dataset.handle || "").trim().toLowerCase();
    const menu = menusByKey.get(key);
    if (menu) itemToMenu.set(item, menu);
  });

  let hideTimeout = null;
  let showTimeout = null;
  let activeMenu = null;
  let activeMenuItem = null;
  let pendingMenuItem = null;
  let hoverTimeout = null;
  let lastTouchTime = 0;

  // Tap/compact priming state: first tap/click opens, second navigates
  let tapPrimeCleanup = null;
  let tapPrimedToNavigate = new WeakSet();

  function showMenu(menuItem) {
    const targetMenu = itemToMenu.get(menuItem);
    if (!targetMenu || targetMenu === activeMenu) return;

    if (activeMenu) activeMenu.classList.remove("mega-menu--active");
    if (activeMenuItem) {
      activeMenuItem.classList.remove(
        "main-nav__item--active-mega",
        "main-nav__item--hover-locked"
      );
      activeMenuItem.setAttribute("aria-expanded", "false");
    }

    megaMenuWrapper.classList.add("mega-menu-wrapper--active");
    targetMenu.classList.add("mega-menu--active");
    menuItem.classList.add(
      "main-nav__item--active-mega",
      "main-nav__item--hover-locked"
    );
    menuItem.setAttribute("aria-expanded", "true");
    sectionHeader?.classList.add(
      "section-header--nav-open",
      "section-header--nav-hover"
    );

    playVideos(targetMenu);

    activeMenu = targetMenu;
    activeMenuItem = menuItem;
    pendingMenuItem = null;
  }

  function hideAllMenus() {
    if (activeMenu) {
      pauseVideos(activeMenu);
      activeMenu.classList.remove("mega-menu--active");
      activeMenu = null;
    }
    if (activeMenuItem) {
      activeMenuItem.classList.remove(
        "main-nav__item--active-mega",
        "main-nav__item--hover-locked"
      );
      activeMenuItem.setAttribute("aria-expanded", "false");
      activeMenuItem = null;
    }
    megaMenuWrapper.classList.remove("mega-menu-wrapper--active");

    // Remove nav-hover sempre
    sectionHeader?.classList.remove("section-header--nav-hover");

    // Remove nav-open apenas se o menu mobile estiver fechado
    const mobileNavToggle = document.querySelector(".mobile-nav-toggle");
    const isMobileMenuClosed =
      !mobileNavToggle ||
      mobileNavToggle.getAttribute("aria-expanded") === "false";

    if (isMobileMenuClosed) {
      sectionHeader?.classList.remove("section-header--nav-open");
    }
  }

  function scheduleShow(menuItem) {
    if (!hoverMode) return; // never schedule hover shows when hover disabled
    clearTimeout(hideTimeout);
    clearTimeout(showTimeout);
    pendingMenuItem = menuItem;
    showTimeout = setTimeout(() => {
      if (pendingMenuItem === menuItem) showMenu(menuItem);
    }, ANIMATION_DELAY);
  }

  function scheduleHide() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    pendingMenuItem = null;
    hideTimeout = setTimeout(() => {
      hideAllMenus();
    }, ANIMATION_DELAY);
  }

  function cancelScheduled() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    pendingMenuItem = null;
  }

  function playVideos(menu) {
    menu.querySelectorAll(".mega-menu__video").forEach((video) => {
      video.muted = true;
      video.play().catch(() => {});
    });
  }

  function pauseVideos(menu) {
    menu.querySelectorAll(".mega-menu__video").forEach((video) => {
      video.pause();
      video.currentTime = 0;
    });
  }

  function addHeaderHover() {
    if (!hoverMode) return;
    clearTimeout(hoverTimeout);
    sectionHeader?.classList.add("section-header--nav-hover");
  }

  function removeHeaderHover() {
    if (!hoverMode) return;
    clearTimeout(hoverTimeout);
    hoverTimeout = setTimeout(() => {
      if (!activeMenu) {
        sectionHeader?.classList.remove("section-header--nav-hover");
      }
    }, ANIMATION_DELAY);
  }

  // --- NEW: strong reset when layout/hover capabilities change --------------
  function resetResponsiveState() {
    // Stop timers & close menus
    cancelScheduled();
    hideAllMenus();

    // Clear header classes decisively
    sectionHeader?.classList.remove(
      "section-header--nav-hover",
      "section-header--nav-open"
    );

    // Remove any hover-locked visual state
    allMenuItems.forEach((el) =>
      el.classList.remove(
        "main-nav__item--hover-locked",
        "main-nav__item--active-mega"
      )
    );

    // Clear aria-expanded on top-level items
    allMenuItems.forEach((el) => el.setAttribute("aria-expanded", "false"));

    // Clear priming window for taps/clicks
    clearTimeout(tapPrimeCleanup);
    tapPrimedToNavigate = new WeakSet();

    // If a mobile toggle exists, force it to "closed" when switching to desktop
    const mobileNavToggle = document.querySelector(".mobile-nav-toggle");
    if (
      mqWidth.matches &&
      mobileNavToggle &&
      mobileNavToggle.getAttribute("aria-expanded") === "true"
    ) {
      mobileNavToggle.setAttribute("aria-expanded", "false");
    }

    // If focus is trapped in the menu, release it
    if (
      document.activeElement &&
      megaMenuWrapper.contains(document.activeElement)
    ) {
      document.activeElement.blur?.();
    }
  }
  // --------------------------------------------------------------------------

  // --- Hover listeners bind/unbind -----------------------------------------
  function bindHoverListeners() {
    // top-level items
    allMenuItems.forEach((menuItem) => {
      menuItem.addEventListener("pointerenter", onAnyItemEnter);
      menuItem.addEventListener("pointerleave", onAnyItemLeave);
    });
    // items with mega + their menus
    menuItemsWithMegaMenu.forEach((menuItem) => {
      const relatedMegaMenu = itemToMenu.get(menuItem);
      if (!relatedMegaMenu) return;

      menuItem.addEventListener("pointerenter", onMegaItemEnter);
      menuItem.addEventListener("pointerleave", onMegaItemLeave);

      relatedMegaMenu.addEventListener("pointerenter", onMenuEnter);
      relatedMegaMenu.addEventListener("pointerleave", onMenuLeave);
    });

    const bridge = megaMenuWrapper.querySelector(".mega-menu__bridge");
    if (bridge) {
      bridge.addEventListener("pointerenter", onMenuEnter);
      bridge.addEventListener("pointerleave", onMenuLeave);
    }
  }

  function unbindHoverListeners() {
    allMenuItems.forEach((menuItem) => {
      menuItem.removeEventListener("pointerenter", onAnyItemEnter);
      menuItem.removeEventListener("pointerleave", onAnyItemLeave);
    });
    menuItemsWithMegaMenu.forEach((menuItem) => {
      const relatedMegaMenu = itemToMenu.get(menuItem);
      if (!relatedMegaMenu) return;

      menuItem.removeEventListener("pointerenter", onMegaItemEnter);
      menuItem.removeEventListener("pointerleave", onMegaItemLeave);

      relatedMegaMenu.removeEventListener("pointerenter", onMenuEnter);
      relatedMegaMenu.removeEventListener("pointerleave", onMenuLeave);
    });

    const bridge = megaMenuWrapper.querySelector(".mega-menu__bridge");
    if (bridge) {
      bridge.removeEventListener("pointerenter", onMenuEnter);
      bridge.removeEventListener("pointerleave", onMenuLeave);
    }
  }
  // --------------------------------------------------------------------------

  function attachListeners() {
    // Touch/click listeners always on (work on mobile & desktop)
    menuItemsWithMegaMenu.forEach((menuItem) => {
      const relatedMegaMenu = itemToMenu.get(menuItem);
      if (!relatedMegaMenu) return;

      // TOUCH
      menuItem.addEventListener("touchstart", onMegaItemTouch, {
        passive: false,
      });

      // CLICK (handles compact-layout first-click-open)
      menuItem.addEventListener("click", onMegaItemClick);

      relatedMegaMenu.addEventListener("click", onMegaMenuClick);
      relatedMegaMenu.addEventListener("touchstart", onMegaMenuTouch);

      const backButton = relatedMegaMenu.querySelector(".mega-menu__back");
      if (backButton) {
        backButton.addEventListener("click", onBackButtonClick);
      }
    });

    document.addEventListener("click", onDocClick, true);
    document.addEventListener("touchstart", onDocTouch, { passive: true });
    document.addEventListener("keydown", onKeydown);
    document.addEventListener("visibilitychange", onVisibility);

    // Initial hover binding according to mode
    if (hoverMode) bindHoverListeners();

    // React to environment changes — ALWAYS reset state on any change
    mqHover.addEventListener("change", onMediaChange);
    mqWidth.addEventListener("change", onMediaChange);
  }

  function onMediaChange() {
    const nextHoverMode = computeHoverMode();
    const nextSmallLayout = isSmallLayout();

    const hoverChanged = nextHoverMode !== hoverMode;
    const layoutChanged = nextSmallLayout !== smallLayout;

    // Store new flags
    hoverMode = nextHoverMode;
    smallLayout = nextSmallLayout;

    // Rebind hover listeners if needed
    if (hoverChanged) {
      if (hoverMode) {
        bindHoverListeners();
      } else {
        unbindHoverListeners();
      }
    }

    // IMPORTANT: whenever layout threshold flips OR hover capability flips,
    // reset all responsive/mobile state so nothing remains "locked".
    if (hoverChanged || layoutChanged) {
      resetResponsiveState();
    }
  }

  // ---------------------- Event handlers ------------------------------------
  function onAnyItemEnter() {
    if (!hoverMode) return;
    const now = Date.now();
    if (now - lastTouchTime < 500) return;
    addHeaderHover();
  }

  function onAnyItemLeave() {
    if (!hoverMode) return;
    removeHeaderHover();
  }

  function onMegaItemEnter(e) {
    if (!hoverMode) return;
    const now = Date.now();
    if (now - lastTouchTime < 500) return;

    const item = e.currentTarget;
    const relatedMegaMenu = itemToMenu.get(item);
    if (!relatedMegaMenu) return;
    if (activeMenu === relatedMegaMenu) {
      cancelScheduled();
    } else {
      scheduleShow(item);
    }
  }

  function onMegaItemLeave(e) {
    if (!hoverMode) return;
    const now = Date.now();
    if (now - lastTouchTime < 500) return;

    const item = e.currentTarget;
    const relatedMegaMenu = itemToMenu.get(item);
    const toElement = e.relatedTarget;

    if (toElement && relatedMegaMenu) {
      const goingToMegaMenu =
        toElement.closest(".mega-menu") === relatedMegaMenu;
      const goingToBridge = toElement.closest(".mega-menu__bridge");
      const goingToWrapper = toElement.closest(".mega-menu-wrapper");

      if (goingToMegaMenu || goingToBridge || goingToWrapper) {
        return;
      }
    }

    scheduleHide();
  }

  function onMegaItemTouch(e) {
    lastTouchTime = Date.now();
    const item = e.currentTarget;
    const relatedMegaMenu = itemToMenu.get(item);
    if (!relatedMegaMenu) return;

    // If already active, allow default tap to navigate.
    if (activeMenu === relatedMegaMenu) return;

    // First tap on an inactive item: open the mega menu, don't navigate.
    e.preventDefault();
    e.stopPropagation();

    cancelScheduled();
    showMenu(item);

    // Prime this item so the next tap/click navigates.
    tapPrimedToNavigate.add(item);
    clearTimeout(tapPrimeCleanup);
    tapPrimeCleanup = setTimeout(() => tapPrimedToNavigate.delete(item), 2000);
  }

  function onMegaItemClick(e) {
    const item = e.currentTarget;
    const relatedMegaMenu = itemToMenu.get(item);

    // If the item was just opened via touch, the synthetic click will fire — swallow it once.
    if (tapPrimedToNavigate.has(item)) {
      e.preventDefault();
      e.stopPropagation();
      tapPrimedToNavigate.delete(item);
      return;
    }

    // Compact layout (<768px) should behave like touch even on non-touch screens:
    if (isSmallLayout() && relatedMegaMenu) {
      // If already open, allow navigation.
      if (activeMenu === relatedMegaMenu) {
        return; // navigate normally
      }

      // First click should open instead of navigating
      e.preventDefault();
      e.stopPropagation();

      cancelScheduled();
      showMenu(item);

      tapPrimedToNavigate.add(item);
      clearTimeout(tapPrimeCleanup);
      tapPrimeCleanup = setTimeout(
        () => tapPrimedToNavigate.delete(item),
        2000
      );
      return;
    }

    // Otherwise (>=768px), clicks behave like normal links; hover handles opening.
  }

  function onMegaMenuClick(e) {
    e.stopPropagation();
  }

  function onMegaMenuTouch(e) {
    e.stopPropagation();
  }

  function onMenuEnter() {
    if (!hoverMode) return;
    cancelScheduled();
    addHeaderHover();
    if (activeMenuItem) {
      activeMenuItem.classList.add("main-nav__item--hover-locked");
    }
  }

  function onMenuLeave(e) {
    if (!hoverMode) return;
    const toElement = e.relatedTarget;

    if (toElement) {
      const goingToMenuItem =
        toElement.closest(".main-nav__item--has-mega-menu") === activeMenuItem;
      const goingToBridge = toElement.closest(".mega-menu__bridge");

      if (goingToMenuItem || goingToBridge) {
        return;
      }
    }

    scheduleHide();
  }

  function onBackButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();
    cancelScheduled();
    hideAllMenus();
  }

  function onDocClick(event) {
    if (Date.now() - lastTouchTime < 100) {
      return;
    }

    if (event.target.closest(".mega-menu__back")) {
      return;
    }

    if (event.target.closest(".mega-menu")) {
      return;
    }

    if (event.target.closest(".mega-menu-wrapper")) {
      return;
    }

    const clickedOutside = !event.target.closest(
      ".main-nav__item--has-mega-menu"
    );

    if (clickedOutside) {
      cancelScheduled();
      hideAllMenus();
      const mobileNavToggle = document.querySelector(".mobile-nav-toggle");
      const isMobileMenuClosed =
        !mobileNavToggle ||
        mobileNavToggle.getAttribute("aria-expanded") === "false";

      if (isMobileMenuClosed) {
        sectionHeader?.classList.remove("section-header--nav-hover");
      }
    }
  }

  function onDocTouch(event) {
    if (event.target.closest(".mega-menu__back")) {
      return;
    }

    if (event.target.closest(".mega-menu")) {
      return;
    }

    if (event.target.closest(".mega-menu-wrapper")) {
      return;
    }

    const touchedOutside = !event.target.closest(
      ".main-nav__item--has-mega-menu"
    );

    if (touchedOutside) {
      lastTouchTime = Date.now();
      cancelScheduled();
      hideAllMenus();
      const mobileNavToggle = document.querySelector(".mobile-nav-toggle");
      const isMobileMenuClosed =
        !mobileNavToggle ||
        mobileNavToggle.getAttribute("aria-expanded") === "false";

      if (isMobileMenuClosed) {
        sectionHeader?.classList.remove("section-header--nav-hover");
      }
    }
  }

  function onKeydown(event) {
    if (event.key === "Escape") {
      cancelScheduled();
      hideAllMenus();
      sectionHeader?.classList.remove("section-header--nav-hover");
      return;
    }

    // Enter to open in compact layout if focused on a mega item
    if (event.key === "Enter" && isSmallLayout()) {
      const item = document.activeElement?.closest(
        ".main-nav__item--has-mega-menu"
      );
      if (item && itemToMenu.has(item) && activeMenu !== itemToMenu.get(item)) {
        event.preventDefault();
        cancelScheduled();
        showMenu(item);
        tapPrimedToNavigate.add(item);
        clearTimeout(tapPrimeCleanup);
        tapPrimeCleanup = setTimeout(
          () => tapPrimedToNavigate.delete(item),
          2000
        );
      }
    }
  }

  function onVisibility() {
    if (document.hidden) {
      cancelScheduled();
      hideAllMenus();
      sectionHeader?.classList.remove("section-header--nav-hover");
    }
  }

  attachListeners();
});
